import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function ShipmentSorting() {
  return <WarehouseOpsPage mode="sort" title="Shipment Sorting" subtitle="Organize shipments by route or destination" />;
}
